import * as React from 'react';
export const wifiSvg = React.forwardRef(function wifiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.619 5.619C3.167 4.069 5.549 3.25 8 3.25s4.832.82 6.381 2.369A.875.875 0 1 0 15.62 4.38C13.668 2.43 10.799 1.5 8 1.5c-2.799 0-5.667.93-7.619 2.881A.875.875 0 0 0 1.62 5.62ZM8 7.875c-1.326 0-2.583.445-3.381 1.244A.875.875 0 1 1 3.38 7.88C4.583 6.68 6.326 6.125 8 6.125s3.418.555 4.619 1.756A.875.875 0 0 1 11.38 9.12c-.798-.8-2.054-1.245-3.38-1.245ZM8 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z',
    }),
  );
});
wifiSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wifi = {
  category: 'icon',
  colorable: true,
  name: 'wifi',
  svg: wifiSvg,
};
